module.exports = __webpack_public_path__ + "static/media/intro.c0954d30.mp3";